export default function getIdsProducts(sections) {
  return sections?.reduce((acc, section) => {
    const { products } = section;
    if (products.length) {
      acc.push(...products.map(product => product.id));
    }
    return acc;
  }, []);
}
